import { useCallback, useMemo, useState } from 'react';
import { ICompanyLocationSelect } from './types';
import LocationSelect from '../location-select/location-select';
import {
  CompanyLocationStatusEnum,
  IGetCompanyLocationsArgs,
  useGetCompanyLocationsQuery,
} from 'redux-store/api/company-location';
import { ISelectController } from 'controllers/select-controller';

const getDefaultLocationsParams = (): IGetCompanyLocationsArgs => ({
  limit: 10,
  status: CompanyLocationStatusEnum.ACTIVE,
  cursor: undefined,
  search: undefined,
});

export const CompanyLocationSelect = ({ ...props }: ICompanyLocationSelect) => {
  const [locationsParams, setLocationsParams] = useState<IGetCompanyLocationsArgs>(() =>
    getDefaultLocationsParams()
  );

  const { data, isFetching } = useGetCompanyLocationsQuery(locationsParams);

  const locationsOptions: ISelectController['options'] = useMemo(
    () =>
      data?.items?.map(({ id, name }) => ({
        value: id,
        label: name,
      })) || [],
    [data?.items]
  );

  const resetLocationsParams = useCallback(() => {
    setLocationsParams(getDefaultLocationsParams());
  }, [getDefaultLocationsParams]);

  return (
    <LocationSelect
      nextCursor={data?.meta?.nextCursor}
      isLocationsFetching={isFetching}
      options={locationsOptions}
      resetLocationsParams={resetLocationsParams}
      setLocationsParams={setLocationsParams}
      {...props}
    />
  );
};
